import React, { FC, useState } from 'react';
import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { formatRoles } from '../../../../utils/user';
import EditUserRoleModal from './EditUserRoleModal';
import { IUserEditState } from '../utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
    },
    label: {
      fontWeight: 'bold',
    },
    right: {
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
    },
    icon: {
      height: 15,
      color: '#FF4340',
      cursor: 'pointer',
    },
    input: {
      flex: 1,
    },
    disabled: {
      color: 'black',
    },
  }),
);

interface Params {
  editable?: boolean;
  userState: IUserEditState;
  setUserState: React.Dispatch<React.SetStateAction<IUserEditState>>;
}

const DetailItemRoles: FC<Params> = (props) => {
  const { editable, userState, setUserState } = props;
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);

  const handleEdit = () => {
    setOpenModal(true);
  };

  return (
    <>
      <Grid item xs={12} sm={2} className={classes.left}>
        <Typography className={classes.label}>Rôle(s) :</Typography>
      </Grid>
      <Grid item xs={11} sm={9} className={classes.left}>
        {userState.roles.map((roleItem) => (
          <Typography key={`value-key-${roleItem}`}>
            {formatRoles(roleItem)}
          </Typography>
        ))}
      </Grid>
      <Grid item xs={1} sm={1} className={classes.right}>
        {editable && <EditIcon className={classes.icon} onClick={handleEdit} />}
      </Grid>
      {openModal && (
        <EditUserRoleModal
          userState={userState}
          setUserState={setUserState}
          setOpenModal={setOpenModal}
        />
      )}
    </>
  );
};

export default DetailItemRoles;
